import React from "react";
import { MARQUEE_WORDS } from "../mock/mock";

export default function Marquee() {
  const sequence = [];
  for (let i = 0; i < 6; i++) sequence.push(...MARQUEE_WORDS);

  const Row = () => (
    <div className="marquee-track">
      {sequence.map((w, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display font-black uppercase text-[clamp(2.5rem,7vw,6rem)] leading-none px-6 ${
              i % 2 === 0 ? "text-[var(--pl-text)]" : "text-outline"
            }`}
          >
            {w}
          </span>
          <span className="text-[var(--pl-text-3)] text-2xl">&bull;</span>
        </span>
      ))}
    </div>
  );

  return (
    <section className="theme-dark overflow-hidden border-y border-[var(--pl-line)] bg-[var(--pl-bg)] py-10 md:py-16">
      <div className="relative w-full">
        <div className="flex">
          <Row />
          <Row />
        </div>
      </div>
    </section>
  );
}
